import { Link } from "react-router-dom";
import { displayPrice, formatRand, isSoldOut, resolveImageUrl } from "../lib/api";

const ProductCard = ({ product, hrefBase = "/product", testIdPrefix = "product" }) => {
  const hasSale = product.sale_price && product.sale_price < product.price;
  const finalPrice = displayPrice(product);
  const soldOut = isSoldOut(product);
  return (
    <Link
      to={`${hrefBase}/${product.id}`}
      className="block group fade-up"
      data-testid={`${testIdPrefix}-card-${product.id}`}
    >
      <div className="product-image-wrap">
        {hasSale && !soldOut && <span className="tag-sale" data-testid={`${testIdPrefix}-sale-tag-${product.id}`}>Sale</span>}
        {soldOut && <span className="tag-sale" data-testid={`${testIdPrefix}-soldout-tag-${product.id}`}>Sold Out</span>}
        <img src={resolveImageUrl(product.images?.[0])} alt={product.name} loading="lazy" style={soldOut ? { opacity: 0.55 } : undefined} />
      </div>
      <div className="mt-4 flex items-start justify-between gap-3">
        <h3 className="font-display text-base uppercase tracking-tight" data-testid={`${testIdPrefix}-name-${product.id}`}>
          {product.name}
        </h3>
        <div className="text-right whitespace-nowrap">
          {hasSale ? (
            <div className="flex flex-col items-end leading-tight">
              <span className="text-xs line-through text-black/40" data-testid={`${testIdPrefix}-original-${product.id}`}>
                {formatRand(product.price)}
              </span>
              <span className="font-display text-base" data-testid={`${testIdPrefix}-price-${product.id}`}>
                {formatRand(finalPrice)}
              </span>
            </div>
          ) : (
            <span className="font-display text-base" data-testid={`${testIdPrefix}-price-${product.id}`}>
              {formatRand(finalPrice)}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
